import { ISeoDataSchema } from '../../repositories/newbuilding-promos/entities/seo_data/SeoDataSchema';
import { mkMarkedList } from '../mocks/markedList';
import { mkPromoCategoryDetails } from '../mocks/promoCategoryDetails';

// TODO: Заменить на респонс новой ручки в CD-203174
interface IResult extends ISeoDataSchema {}

export const getSeoDataMk = (props: {
  description?: string;
  title?: string;
  h1?: string;
  pageDescription?: string | null;
  subheader?: string;
  // TODO: Заменить на тип новой ручки в CD-203174
  markedList?: any;
  // TODO: Заменить на тип новой ручки в CD-203174
  promoCategoryDetails?: any;
}): IResult => {
  const {
    description = 'description',
    title = 'title',
    h1 = 'h1',
    pageDescription = 'pageDescription',
    subheader = 'Каталог акций',
    markedList = mkMarkedList(),
    promoCategoryDetails = mkPromoCategoryDetails(),
  } = props;

  return {
    description,
    pageDescription,
    title,
    h1,
    subheader,
    markedList,
    promoCategoryDetails,
  } as IResult;
};
